import { getLocationHref, _global, replaceAop, isExistProperty, on, throttle, debounce } from '../utils/unils.js';
import { mirrorUserLogIns } from './handleUserlog.js';

let lastHref = getLocationHref();
function supportsHistory() {
    const chrome = _global.chrome;
    const isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    const hasHistoryApi = 'history' in _global && !!_global.history.pushState && !!_global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}
const HandlerUserReplace = {
    // history路由监听
    historyReplace() {
        // 是否支持history
        if (!supportsHistory())
            return;
        const oldOnpopstate = _global.onpopstate;
        // 添加 onpopstate事件
        _global.onpopstate = function (...args) {
            const to = getLocationHref();
            const from = lastHref;
            lastHref = to;
            mirrorUserLogIns.handleHistory({ from, to });
            oldOnpopstate && oldOnpopstate.apply(this, args);
        };
        function historyReplaceFn(originalHistoryFn) {
            return function (...args) {
                const url = args.length > 2 ? args[2] : undefined;
                if (url) {
                    const from = lastHref;
                    const to = String(url);
                    lastHref = to;
                    mirrorUserLogIns.handleHistory({ from, to });
                }
                return originalHistoryFn.apply(this, args);
            };
        }
        // 重写pushState、replaceState事件
        replaceAop(_global.history, 'pushState', historyReplaceFn);
        replaceAop(_global.history, 'replaceState', historyReplaceFn);
    },
    // hash路由监听
    hashChangeReplace() {
        if (isExistProperty(_global, 'onhashchange')) {
            on(_global, 'hashchange', function (e) {
                mirrorUserLogIns.handleHashChange(e);
            });
        }
    },
    // click-dom监听
    domClickReplace() {
        if (!('document' in _global))
            return;
        const clickThrottle = throttle(mirrorUserLogIns.handleDomClick, 300);
        on(_global.document, 'click', function (e) {
            clickThrottle(e);
        }, true);
    },
    // 监听页面滚动,节流1秒，滚动比较频繁
    scrollReplace() {
        const clickDebounce = debounce(mirrorUserLogIns.handleScroll, 1000);
        on(_global, 'scroll', function (e) {
            clickDebounce(e);
        }, true);
    },
    // js错误日志
    jsErrorReplace(data) {
        mirrorUserLogIns === null || mirrorUserLogIns === void 0 ? void 0 : mirrorUserLogIns.handleJsError(data);
    },
    //  promise错误日志
    promiseErrorReplace(data) {
        mirrorUserLogIns === null || mirrorUserLogIns === void 0 ? void 0 : mirrorUserLogIns.handlePromiseError(data);
    },
    // resource错误日志
    resourceErrorReplace(data) {
        mirrorUserLogIns === null || mirrorUserLogIns === void 0 ? void 0 : mirrorUserLogIns.handleResourceError(data);
    },
    // 白屏日志
    whiteErrorReplace() {
        mirrorUserLogIns === null || mirrorUserLogIns === void 0 ? void 0 : mirrorUserLogIns.handleWhiteScreen();
    },
    // api相关记录(仅支持canBatchReport-不考虑代理xhr和fetch请求)
    apiReplace(data) {
        mirrorUserLogIns === null || mirrorUserLogIns === void 0 ? void 0 : mirrorUserLogIns.handleRequest(data);
    }
};

export { HandlerUserReplace };
